import React from "react";
import { useDownloadUrl } from "src/customHooks/useDownloadUr";

type AudioPlayerProps = {
  url: string;
};

export const AudioPlayer: React.FC<AudioPlayerProps> = ({ url }) => {
  const { fileUrl } = useDownloadUrl(url);

  return fileUrl ? (
    <div className="text-center mt-4">
      {url ? (
        <audio controls className="w-full mt-2">
          <source src={fileUrl} type="audio/mp3" />
          Your browser does not support the audio element.
        </audio>
      ) : (
        <div className="text-sm text-red-600">⚠️ File not found</div>
      )}
    </div>
  ) : (
    <></>
  );
};
